define.alias("ember-composable-helpers/helpers/reduce", "calendar/helpers/reduce");